









class spartaGlobalDataUtility {
  constructor(){
  	console.log('%cDEPRECATED ', 'color: red', 'use spartaStore for global data');
  }
}


export default spartaGlobalDataUtility;
